import React from 'react'
import { AlertWarning } from '../../../Student/Dashboard/Widget/WarningStudyPeriode';

export function WarningStudyPeriode({ student }) {
  const current_program = student?.program?.id || "";
  const current_semester = student?.semester || 0;
  const maxSemesterBachelor = 14;
  const maxSemesterMaster = 8;

  if (current_program === 1 && (current_semester === 13 || current_semester === 14)) {
    return (
      <AlertWarning
        title={"Study Period Warning!"}
        message={`This student has ${maxSemesterBachelor - current_semester} semesters remaining in their study period. Please assist them in planning their study completion and help simulate their CGPA/GPA targets for this semester.`}
      />
    );
  }

  if (current_program === 1 && current_semester >= 14) {
    return (
      <AlertWarning
        title={"Study Period Warning!"}
        message={`This student has exceeded the maximum study period of 14 semesters. Please advise them to contact the Academic Office (AOO) for further assistance.`}
      />
    );
  }

  if (current_program === 2 && (current_semester == 7 || current_semester === 8)) {
    return (
      <AlertWarning
        title={"Study Period Warning!"}
        message={`This student has ${maxSemesterMaster - current_semester} semesters remaining in their study period. Please assist them in planning their study completion and help simulate their CGPA/GPA targets for this semester.`}
      />
    );
  }

  if (current_program === 2 && current_semester >= 8) {
    return (
      <AlertWarning
        title={"Study Period Warning!"}
        message={`This student has exceeded the maximum study period of 8 semesters. Please advise them to contact the Academic Office (AOO) for further assistance.`}
      />
    );
  }

  return "";
}
